var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"content",attrs:{"src":"http://127.0.0.1:3501/new-kop/airwallex/card"}}),_vm._v(" "),_c('iframe',{attrs:{"src":"http://127.0.0.1:3501/new-kop/airwallex/expiry"}}),_vm._v(" "),_c('button',{staticClass:"mt-10 w-[100px] h-[32px] flex items-center justify-center border",on:{"click":_vm.handlePay}},[_vm._v("支付")])])
}
var staticRenderFns = []

export { render, staticRenderFns }